import { ITrainerList } from "../../models/response/IAdminResponse";

export const TrainerListState: ITrainerList = {
    TrainerList: [],
  };